import { Form, Input, Switch } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import SensitiveInput from '../SensitiveInput'
import type { OptionsAPI } from '../useOptions'
import { FIXED_PUBLIC_SITE_ORIGIN } from '@/utils/commercialSite'

const KEYS = ['WorkerUrl', 'WorkerValidKey', 'WorkerAllowHttpImageRequestEnabled']

export default function GeneralSection({ options }: { options: OptionsAPI }) {
  const { get, getBool, patch } = options

  return (
    <SettingSectionCard title="通用设置" subtitle="Worker 代理与对外服务根地址（只读）" keys={KEYS} options={options}>
      <Form layout="vertical">
        <Form.Item
          label="对外服务根地址"
          extra={`商业化固定为 ${FIXED_PUBLIC_SITE_ORIGIN}，须与 OAuth/邮件/支付回调一致，不在此编辑。`}
        >
          <Input readOnly value={get('ServerAddress', FIXED_PUBLIC_SITE_ORIGIN)} />
        </Form.Item>
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="Worker URL" extra="仅用于图片转发、Webhook 等，AI 请求仍由服务器直连">
            <Input value={get('WorkerUrl')} onChange={(v) => patch({ WorkerUrl: v })} placeholder="https://worker.example.workers.dev" />
          </Form.Item>
          <Form.Item label="Worker 密钥">
            <SensitiveInput value={get('WorkerValidKey')} onChange={(v) => patch({ WorkerValidKey: v })} />
          </Form.Item>
          <Form.Item label="允许 HTTP 协议图片请求">
            <Switch
              checked={getBool('WorkerAllowHttpImageRequestEnabled')}
              onChange={(v) => patch({ WorkerAllowHttpImageRequestEnabled: v })}
            />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
